import { render, staticRenderFns } from "./NewLoanConfirmation.vue?vue&type=template&id=397c4fd1"
import script from "./NewLoanConfirmation.vue?vue&type=script&lang=js"
export * from "./NewLoanConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports